export default class OverflowScroller {
  constructor(element) {

    if (!element) {
      return;
    }

    this.element = element;
    this.lastKnownY = window.scrollY;
    this.currentTop = 0;
    this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top);

    this._attachListeners();
  }

  destroy() {
    window.removeEventListener('scroll', this._checkPositionListener);
  }
  _attachListeners() {
    this._checkPositionListener = this._checkPosition.bind(this);
    window.addEventListener('scroll', this._checkPositionListener);
  }
  _checkPosition() {
    var _this10 = this;

    fastdom.measure(function () {
      var bounds = _this10.element.getBoundingClientRect(),
          maxTop = bounds.top + window.scrollY - _this10.element.offsetTop + _this10.initialTopOffset,
          minTop = _this10.element.clientHeight - window.innerHeight;

      if (window.scrollY < _this10.lastKnownY) {
        _this10.currentTop -= window.scrollY - _this10.lastKnownY;
      } else {
        _this10.currentTop += _this10.lastKnownY - window.scrollY;
      }

      _this10.currentTop = Math.min(Math.max(_this10.currentTop, -minTop), maxTop, _this10.initialTopOffset);
      _this10.lastKnownY = window.scrollY;
    });

    fastdom.mutate(function () {
      _this10.element.style.top = _this10.currentTop + 'px';
    });
  }
}